<div class="ratSelect" [formGroup]="form">
  <div id="multiselectCustom">
    <div class="drop-toggle btn" id="multiselectCustom" (click)="toggleShowDropdown()" [ngClass]="eachControl.isDisabled ? (isArabic ? 'rightAlign disabledMultiselect' : 'disabledMultiselect') : 
      (isArabic ? 'rightAlign' : '')">
      <ng-container *ngIf="checkedList.length <= 0">
        <span *ngIf="!isArabic" id="multiselectCustom">Select Option</span>
        <span *ngIf="isArabic" id="multiselectCustom">اختر خياراً</span>
      </ng-container>
      <span *ngIf="!isArabic && checkedList.length > 0" id="multiselectCustom">{{checkedList.join(', ')}}</span>
      <span *ngIf="isArabic && arabicCheckedList.length > 0" id="multiselectCustom">{{arabicCheckedList.join(',
        ')}}</span>
    </div>
    <div class="drop-show" *ngIf="showDropDown" id="multiselectCustom">
      <div *ngFor="let opt of eachControl?.options; let idx=index;" class="eachOption"
        [ngClass]="isArabic ? 'arabicAlign' : ''" id="multiselectCustom">
        <input type="checkbox" [formControlName]="question?.quesId+'_id_'+controlIndex"
          [name]="'check_'+controlIndex+'_'+idx" [id]="'check_'+controlIndex+'_'+idx" [attr.disabled]="isDisabled"
          id="multiselectCustom" />
        <div class="tickDiv" (click)="getSelectedValue(opt, idx, question?.quesId+'_id_'+controlIndex)"
          id="multiselectCustom">
          <div class="tick" [ngClass]="isArabic ? 'arabicRightAlign' : ''" id="multiselectCustom">
            <img src="../../../../assets/images/tick.png" *ngIf="opt.checked" id="multiselectCustom" />
          </div>
          <span *ngIf="!isArabic || (isArabic && !opt.valueArabic)" id="multiselectCustom">{{opt.value}}</span>
          <span *ngIf="isArabic && opt.valueArabic" id="multiselectCustom">{{opt.valueArabic}}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container class="error-container" *ngIf="isValid != undefined && !isValid">
  <app-rat-errormsg [question]="question" [eachControl]="eachControl" [controlIndex]="controlIndex"
    [form]="form"></app-rat-errormsg>
</ng-container>